import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/versions/new")({
  staticData: {
    title: "common.new",
  },
});
